module.exports = __webpack_public_path__ + "static/media/placed-order.8810552d.svg";